import { DE_DE_LOCALE, EN_DE_LOCALE, FR_FR_LOCALE, EN_FR_LOCALE, NL_NL_LOCALE, EN_NL_LOCALE, ES_US_LOCALE, EN_GB_LOCALE, EN_US_LOCALE, EN_LANGUAGE, DE_LANGUAGE } from '../locale/locale_config.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ALL_COUNTRIES = [
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TA",
    "TC",
    "TD",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "XK",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW"
];
var ALL_COUNTRY_ALIASES = [
    "UK"
];
var COUNTRY_ISO_ALIASES_MAP = {
    UK: "GB"
};
var EUROPEAN_GDPR_COUNTRIES = [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GB",
    "GR",
    "HR",
    "HU",
    "IE",
    "IS",
    "IT",
    "LI",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK"
];
/* cspell:disable */ var EN_COUNTRY_LOCALE = {
    AF: "Afghanistan",
    AX: "\xc5land Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    VG: "British Virgin Islands",
    BT: "Bhutan",
    BO: "Bolivia",
    BQ: "Caribbean Netherlands",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CK: "Cook Islands",
    CR: "Costa Rica",
    HR: "Croatia",
    CU: "Cuba",
    CW: "Cura\xe7ao",
    CY: "Cyprus",
    CZ: "Czech Republic",
    CD: "Congo - Kinshasa",
    CG: "Congo - Brazzaville",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    SZ: "Eswatini",
    ET: "Ethiopia",
    FK: "Falkland Islands",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "Polyn\xe9sie fran\xe7aise",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle of Man",
    IL: "Israel",
    IT: "Italy",
    CI: "C\xf4te d'Ivoire",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    XK: "Kosovo",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Laos",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macau",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    KP: "North Korea",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestine",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "P\xe9rou",
    PH: "Philippines",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "R\xe9union",
    RO: "Romania",
    RW: "Rwanda",
    RU: "Russia",
    BL: "Saint Barth\xe9lemy",
    SH: "Saint Helena",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin",
    PM: "Saint Pierre and Miquelon",
    VC: "Saint Vincent and the Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "S\xe3o Tom\xe9 and Pr\xedncipe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SX: "Sint Maarten",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    KR: "South Korea",
    SS: "South Sudan",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard and Jan Mayen",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syria",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: "T\xfcrkiye",
    TM: "Turkmenistan",
    TC: "Turks and Caicos Islands",
    TV: "Tuvalu",
    VI: "U.S. Virgin Islands",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    UK: "United Kingdom",
    GB: "United Kingdom",
    US: "United States",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VA: "Vatican City",
    VE: "Venezuela",
    VN: "Vietnam",
    WF: "Wallis and Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe"
};
var _obj;
/* cspell:enable */ var FRIENDLY_NAME = (_obj = {}, /* cspell:disable */ _define_property(_obj, DE_DE_LOCALE, {
    AD: "Andorra",
    AE: "Vereinigte Arabische Emirate",
    AF: "Afghanistan",
    AI: "Anguilla",
    AL: "Albanien",
    AM: "Armenien",
    AO: "Angola",
    AR: "Argentinien",
    AS: "Amerikanisch-Samoa",
    AT: "\xd6sterreich",
    AU: "Australien",
    AW: "Aruba",
    AX: "\xc5landinseln",
    AZ: "Aserbaidschan",
    BA: "Bosnien und Herzegowina",
    BB: "Barbados",
    BD: "Bangladesch",
    BE: "Belgien",
    BF: "Burkina Faso",
    BG: "Bulgarien",
    BH: "Bahrain",
    BI: "Burundi",
    BJ: "Benin",
    BL: "Saint-Barth\xe9lemy",
    BM: "Bermuda",
    BN: "Brunei",
    BO: "Bolivien",
    BQ: "Karibische Niederlande",
    BR: "Brasilien",
    BS: "Bahamas",
    BT: "Bhutan",
    BW: "Botswana",
    BY: "Wei\xdfrussland",
    BZ: "Belize",
    CA: "Kanada",
    CC: "Kokosinseln",
    CD: "Demokratische Republik Kongo",
    CF: "Zentralafrikanische Republik",
    CG: "Republik Kongo",
    CH: "Schweiz",
    CI: "Elfenbeink\xfcste",
    CK: "Cookinseln",
    CL: "Chile",
    CM: "Kamerun",
    CN: "China",
    CO: "Kolumbien",
    CR: "Costa Rica",
    CU: "Kuba",
    CV: "Kap Verde",
    CW: "Cura\xe7ao",
    CX: "Weihnachtsinsel",
    CY: "Zypern",
    CZ: "Czech Republic",
    DE: "Deutschland",
    DJ: "Dschibuti",
    DK: "D\xe4nemark",
    DM: "Dominica",
    DO: "Dominikanische Republik",
    DZ: "Algerien",
    EC: "Ecuador",
    EE: "Estland",
    EG: "\xc4gypten",
    EH: "Westsahara",
    ER: "Eritrea",
    ES: "Spanien",
    ET: "\xc4thiopien",
    FI: "Finnland",
    FJ: "Fidschi",
    FK: "Falklandinseln",
    FM: "Mikronesien",
    FO: "F\xe4r\xf6er",
    FR: "Frankreich",
    GA: "Gabun",
    GB: "Vereinigtes K\xf6nigreich",
    GD: "Grenada",
    GE: "Georgien",
    GF: "Franz\xf6sisch-Guayana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Gr\xf6nland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Guadeloupe",
    GQ: "\xc4quatorialguinea",
    GR: "Griechenland",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HK: "Hongkong",
    HN: "Honduras",
    HR: "Kroatien",
    HT: "Haiti",
    HU: "Ungarn",
    ID: "Indonesien",
    IE: "Irland",
    IL: "Israel",
    IM: "Isle of Man",
    IN: "Indien",
    IO: "Britisches Territorium im Indischen Ozean",
    IQ: "Irak",
    IR: "Iran",
    IS: "Island",
    IT: "Italien",
    JE: "Jersey",
    JM: "Jamaika",
    JO: "Jordanien",
    JP: "Japan",
    KE: "Kenia",
    KG: "Kirgisistan",
    KH: "Kambodscha",
    KI: "Kiribati",
    KM: "Komoren",
    KN: "St. Kitts und Nevis",
    KP: "Nordkorea",
    KR: "S\xfcdkorea",
    KW: "Kuwait",
    KY: "Kaimaninseln",
    KZ: "Kasachstan",
    LA: "Laos",
    LB: "Libanon",
    LC: "St. Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Litauen",
    LU: "Luxemburg",
    LV: "Lettland",
    LY: "Libyen",
    MA: "Marokko",
    MC: "Monaco",
    MD: "Moldawien",
    ME: "Montenegro",
    MF: "Saint-Martin",
    MG: "Madagaskar",
    MH: "Marshallinseln",
    MK: "Mazedonien",
    ML: "Mali",
    MM: "Myanmar",
    MN: "Mongolei",
    MO: "Macau",
    MP: "N\xf6rdliche Marianen",
    MQ: "Martinique",
    MR: "Mauretanien",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Malediven",
    MW: "Malawi",
    MX: "Mexiko",
    MY: "Malaysia",
    MZ: "Mosambik",
    NA: "Namibia",
    NC: "Neukaledonien",
    NE: "Niger",
    NF: "Norfolkinsel",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Niederlande",
    NO: "Norwegen",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "Neuseeland",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "Franz\xf6sisch-Polynesien",
    PG: "Papua-Neuguinea",
    PH: "Philippinen",
    PK: "Pakistan",
    PL: "Polen",
    PM: "Saint-Pierre und Miquelon",
    PR: "Puerto Rico",
    PS: "Pal\xe4stina",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Katar",
    RE: "R\xe9union",
    RO: "Rum\xe4nien",
    RS: "Serbien",
    RU: "Russland",
    RW: "Ruanda",
    SA: "Saudi-Arabien",
    SB: "Salomonen",
    SC: "Seychellen",
    SD: "Sudan",
    SE: "Schweden",
    SG: "Singapur",
    SH: "St. Helena",
    SI: "Slowenien",
    SJ: "Spitzbergen und Jan Mayen",
    SK: "Slowakei",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    SS: "S\xfcdsudan",
    ST: "S\xe3o Tom\xe9 und Pr\xedncipe",
    SV: "El Salvador",
    SX: "Sint Maarten",
    SY: "Syrien",
    SZ: "Eswatini",
    TC: "Turks- und Caicosinseln",
    TD: "Tschad",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tadschikistan",
    TK: "Tokelau",
    TL: "Osttimor",
    TM: "Turkmenistan",
    TN: "Tunesien",
    TO: "Tonga",
    TR: "T\xfcrkei",
    TT: "Trinidad und Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tansania",
    UA: "Ukraine",
    UG: "Uganda",
    UK: "Vereinigtes K\xf6nigreich",
    US: "Vereinigte Staaten",
    UY: "Uruguay",
    UZ: "Usbekistan",
    VA: "Vatikanstadt",
    VC: "St. Vincent und die Grenadinen",
    VE: "Venezuela",
    VG: "Britische Jungferninseln",
    VI: "Amerikanische Jungferninseln",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis und Futuna",
    WS: "Samoa",
    XK: "Kosovo",
    YE: "Jemen",
    YT: "Mayotte",
    ZA: "S\xfcdafrika",
    ZM: "Sambia",
    ZW: "Simbabwe"
}), _define_property(_obj, EN_DE_LOCALE, EN_COUNTRY_LOCALE), _define_property(_obj, FR_FR_LOCALE, {
    ZA: "Afrique du Sud",
    AF: "Afghanistan",
    AL: "Albanie",
    DZ: "Alg\xe9rie",
    DE: "Allemagne",
    AD: "Andorre",
    AO: "Angola",
    AI: "Anguilla",
    SA: "Arabie Saoudite",
    AR: "Argentine",
    AM: "Arm\xe9nie",
    AW: "Aruba",
    AU: "Australie",
    AT: "Autriche",
    AZ: "Azerba\xefdjan",
    BS: "Bahamas",
    BH: "Bahre\xefn",
    BD: "Bangladesh",
    BB: "Barbade",
    BE: "Belgique",
    BZ: "Belize",
    BJ: "B\xe9nin",
    BL: "Saint-Barth\xe9lemy",
    BM: "Bermudes",
    BT: "Bhoutan",
    BY: "Bi\xe9lorussie",
    MM: "Myanmar",
    BO: "Bolivie",
    BA: "Bosnie-Herz\xe9govine",
    BW: "Botswana",
    BR: "Br\xe9sil",
    BN: "Brunei",
    BG: "Bulgarie",
    BF: "Burkina Faso",
    BI: "Burundi",
    KY: "\xceles Ca\xefmans",
    KH: "Cambodge",
    CM: "Cameroun",
    CA: "Canada",
    CV: "Cap-Vert",
    CL: "Chili",
    CN: "Chine",
    CY: "Chypre",
    CZ: "R\xe9publique tch\xe8que",
    CO: "Colombie",
    KM: "Comores",
    CG: "R\xe9publique du Congo",
    CD: "R\xe9publique d\xe9mocratique du Congo",
    CC: "\xceles Cocos",
    CF: "R\xe9publique centrafricaine",
    CK: "\xceles Cook",
    KP: "Cor\xe9e du Nord",
    KR: "Cor\xe9e du Sud",
    CR: "Costa Rica",
    CI: "C\xf4te d'Ivoire",
    HR: "Croatie",
    CU: "Cuba",
    CW: "Cura\xe7ao",
    DK: "Danemark",
    DJ: "Djibouti",
    DO: "R\xe9publique dominicaine",
    DM: "Dominique",
    EG: "\xc9gypte",
    SV: "Salvador",
    AE: "\xc9mirats arabes unis",
    ER: "\xc9rythr\xe9e",
    ES: "Espagne",
    EE: "Estonie",
    SZ: "Eswatini",
    US: "\xc9tats-Unis",
    ET: "\xc9thiopie",
    EC: "\xc9quateur",
    FJ: "Fidji",
    FI: "Finlande",
    FR: "France",
    GA: "Gabon",
    GM: "Gambie",
    GE: "G\xe9orgie",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Gr\xe8ce",
    GD: "Grenade",
    GL: "Groenland",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernesey",
    GN: "Guin\xe9e",
    GQ: "Guin\xe9e \xe9quatoriale",
    GW: "Guin\xe9e-Bissau",
    GY: "Guyana",
    GF: "Guyane fran\xe7aise",
    HT: "Ha\xefti",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hongrie",
    IM: "\xcele de Man",
    CX: "\xcele Christmas",
    NF: "\xcele Norfolk",
    FK: "\xceles Malouines",
    AX: "\xceles \xc5land",
    FO: "\xceles F\xe9ro\xe9",
    MP: "\xceles Mariannes du Nord",
    MH: "\xceles Marshall",
    SB: "\xceles Salomon",
    VI: "\xceles Vierges am\xe9ricaines",
    VG: "\xceles Vierges britanniques",
    IS: "Islande",
    IN: "Inde",
    ID: "Indon\xe9sie",
    IQ: "Irak",
    IR: "Iran",
    IE: "Irlande",
    IL: "Isra\xebl",
    IT: "Italie",
    JE: "Jersey",
    JM: "Jama\xefque",
    JP: "Japon",
    JO: "Jordanie",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KG: "Kirghizistan",
    KI: "Kiribati",
    XK: "Kosovo",
    KW: "Kowe\xeft",
    LA: "Laos",
    LS: "Lesotho",
    LV: "Lettonie",
    LB: "Liban",
    LR: "Lib\xe9ria",
    LY: "Libye",
    LI: "Liechtenstein",
    LT: "Lituanie",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Mac\xe9donie",
    MG: "Madagascar",
    MY: "Malaisie",
    MW: "Malawi",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malte",
    MA: "Maroc",
    MQ: "Martinique",
    MR: "Mauritanie",
    MU: "Maurice",
    YT: "Mayotte",
    MX: "Mexique",
    FM: "Micron\xe9sie",
    MD: "Moldavie",
    MC: "Monaco",
    MN: "Mongolie",
    ME: "Montenegro",
    MS: "Montserrat",
    MZ: "Mozambique",
    NA: "Namibie",
    NR: "Nauru",
    NP: "N\xe9pal",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NO: "Norv\xe8ge",
    NC: "Nouvelle-Cal\xe9donie",
    NZ: "Nouvelle-Z\xe9lande",
    OM: "Oman",
    UG: "Ouganda",
    UZ: "Ouzb\xe9kistan",
    PK: "Pakistan",
    PW: "Palaos",
    PS: "Palestine",
    PA: "Panama",
    PG: "Papouasie-Nouvelle-Guin\xe9e",
    PY: "Paraguay",
    NL: "Pays-Bas",
    BQ: "Pays-Bas carib\xe9ens",
    PE: "P\xe9rou",
    PH: "Philippines",
    PL: "Pologne",
    PF: "Polyn\xe9sie fran\xe7aise",
    PR: "Puerto Rico",
    PT: "Portugal",
    QA: "Qatar",
    RE: "La R\xe9union",
    RO: "Roumanie",
    GB: "Royaume-Uni",
    UK: "Royaume-Uni",
    RW: "Rwanda",
    RU: "Russie",
    KN: "Saint-Kitts-et-Nevis",
    LC: "Sainte-Lucie",
    VC: "Saint-Vincent-et-les-Grenadines",
    WS: "Samoa",
    AS: "Samoa am\xe9ricaines",
    SM: "San Marino",
    SH: "Sainte-H\xe9l\xe8ne",
    MF: "Saint-Martin",
    PM: "Saint-Pierre-et-Miquelon",
    ST: "S\xe3o Tom\xe9-et-Pr\xedncipe",
    SN: "S\xe9n\xe9gal",
    RS: "Serbie",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapour",
    SX: "Saint-Martin",
    SK: "Slovaquie",
    SI: "Slov\xe9nie",
    SO: "Somalie",
    SD: "Soudan",
    SS: "Soudan du Sud",
    LK: "Sri Lanka",
    SE: "Su\xe8de",
    CH: "Suisse",
    SR: "Suriname",
    SJ: "Svalbard et Jan Mayen",
    SY: "Syrie",
    TW: "Ta\xefwan",
    TJ: "Tadjikistan",
    TZ: "Tanzanie",
    TH: "Tha\xeflande",
    TD: "Tchad",
    IO: "Territoire britannique de l'oc\xe9an Indien",
    TL: "Timor oriental",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinit\xe9-et-Tobago",
    TN: "Tunisie",
    TM: "Turkm\xe9nistan",
    TC: "\xceles Turques-et-Ca\xefques",
    TR: "T\xfcrkiye",
    TV: "Tuvalu",
    UA: "Ukraine",
    UY: "Uruguay",
    VU: "Vanuatu",
    VA: "Cit\xe9 du Vatican",
    VE: "Venezuela",
    VN: "Vi\xeat Nam",
    WF: "Wallis-et-Futuna",
    EH: "Sahara occidental",
    YE: "Y\xe9men",
    ZM: "Zambie",
    ZW: "Zimbabwe"
}), _define_property(_obj, EN_FR_LOCALE, EN_COUNTRY_LOCALE), _define_property(_obj, NL_NL_LOCALE, {
    AD: "Andorra",
    AE: "Verenigde Arabische Emiraten",
    AF: "Afghanistan",
    AI: "Anguilla",
    AL: "Albani\xeb",
    AM: "Armeni\xeb",
    AO: "Angola",
    AR: "Argentini\xeb",
    AS: "Amerikaans-Samoa",
    AT: "Oostenrijk",
    AU: "Australi\xeb",
    AW: "Aruba",
    AX: "\xc5landeilanden",
    AZ: "Azerbeidzjan",
    BA: "Bosni\xeb en Herzegovina",
    BB: "Barbados",
    BD: "Bangladesh",
    BE: "Belgi\xeb",
    BF: "Burkina Faso",
    BG: "Bulgarije",
    BH: "Bahrein",
    BI: "Burundi",
    BJ: "Benin",
    BL: "Saint-Barth\xe9lemy",
    BM: "Bermuda",
    BN: "Brunei",
    BO: "Bolivia",
    BQ: "Caribisch Nederland",
    BR: "Brazili\xeb",
    BS: "Bahama's",
    BT: "Bhutan",
    BW: "Botswana",
    BY: "Wit-Rusland",
    BZ: "Belize",
    CA: "Canada",
    CC: "Cocoseilanden",
    CD: "Democratische Republiek Congo",
    CF: "Centraal-Afrikaanse Republiek",
    CG: "Congo-Brazzaville",
    CH: "Zwitserland",
    CI: "Ivoorkust",
    CK: "Cookeilanden",
    CL: "Chili",
    CM: "Kameroen",
    CN: "China",
    CO: "Colombia",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Kaapverdi\xeb",
    CW: "Cura\xe7ao",
    CX: "Christmaseiland",
    CY: "Cyprus",
    CZ: "Tsjechi\xeb",
    DE: "Duitsland",
    DJ: "Djibouti",
    DK: "Denemarken",
    DM: "Dominica",
    DO: "Dominicaanse Republiek",
    DZ: "Algerije",
    EC: "Ecuador",
    EE: "Estland",
    EG: "Egypte",
    EH: "Westelijke Sahara",
    ER: "Eritrea",
    ES: "Spanje",
    ET: "Ethiopi\xeb",
    FI: "Finland",
    FJ: "Fiji",
    FK: "Falklandeilanden",
    FM: "Micronesi\xeb",
    FO: "Faer\xf6er",
    FR: "Frankrijk",
    GA: "Gabon",
    GB: "Verenigd Koninkrijk",
    GD: "Grenada",
    GE: "Georgi\xeb",
    GF: "Frans-Guyana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "",
    GL: "Groenland",
    GM: "Gambia",
    GN: "Guinee",
    GP: "Guadeloupe",
    GQ: "Equatoriaal-Guinea",
    GR: "Griekenland",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinee-Bissau",
    GY: "Guyana",
    HK: "Hong Kong",
    HN: "Honduras",
    HR: "Kroati\xeb",
    HT: "Ha\xefti",
    HU: "Hongarije",
    ID: "Indonesi\xeb",
    IE: "Ierland",
    IL: "Isra\xebl",
    IM: "Isle of Man",
    IN: "Indi\xeb",
    IO: "Brits Indische Oceaanterritorium",
    IQ: "Irak",
    IR: "Iran",
    IS: "IJsland",
    IT: "Itali\xeb",
    JE: "Jersey",
    JM: "Jamaica",
    JO: "Jordan",
    JP: "Japan",
    KE: "Kenia",
    KG: "Kirgizi\xeb",
    KH: "Cambodja",
    KI: "Kiribati",
    KM: "Comoren",
    KN: "Saint Kitts en Nevis",
    KP: "Noord-Korea",
    KR: "Zuid-Korea",
    KW: "Koeweit",
    KY: "Kaaimaneilanden",
    KZ: "Kazachstan",
    LA: "Laos",
    LB: "Libanon",
    LC: "Saint Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Litouwen",
    LU: "Luxemburg",
    LV: "Letland",
    LY: "Libi\xeb",
    MA: "Marokko",
    MC: "Monaco",
    MD: "Moldavi\xeb",
    ME: "Montenegro",
    MF: "Saint-Martin",
    MG: "Madagaskar",
    MH: "Marshalleilanden",
    MK: "Macedoni\xeb",
    ML: "Mali",
    MM: "Myanmar",
    MN: "Mongoli\xeb",
    MO: "Macau",
    MP: "Noordelijke Marianen",
    MQ: "Martinique",
    MR: "Mauritani\xeb",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Maldiven",
    MW: "Malawi",
    MX: "Mexico",
    MY: "Maleisi\xeb",
    MZ: "Mozambique",
    NA: "Namibi\xeb",
    NC: "Nieuw-Caledoni\xeb",
    NE: "Niger",
    NF: "Norfolk",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Nederland",
    NO: "Noorwegen",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "Nieuw-Zeeland",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "Frans-Polynesi\xeb",
    PG: "Papoea-Nieuw-Guinea",
    PH: "Filipijnen",
    PK: "Pakistan",
    PL: "Polen",
    PM: "Saint-Pierre en Miquelon",
    PR: "Puerto Rico",
    PS: "Palestina",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Qatar",
    RE: "R\xe9union",
    RO: "Roemeni\xeb",
    RS: "Servi\xeb",
    RU: "Rusland",
    RW: "Rwanda",
    SA: "Saoedi-Arabi\xeb",
    SB: "Salomonseilanden",
    SC: "Seychellen",
    SD: "Soedan",
    SE: "Zweden",
    SG: "Singapore",
    SH: "Sint-Helena",
    SI: "Sloveni\xeb",
    SJ: "Spitsbergen en Jan Mayen",
    SK: "Slowakije",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somali\xeb",
    SR: "Suriname",
    SS: "Zuid-Soedan",
    ST: "Sao Tom\xe9 en Principe",
    SV: "El Salvador",
    SX: "Sint Maarten",
    SY: "Syri\xeb",
    SZ: "Eswatini",
    TC: "Turks- en Caicoseilanden",
    TD: "Tsjaad",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tadzjikistan",
    TK: "Tokelau",
    TL: "Oost-Timor",
    TM: "Turkmenistan",
    TN: "Tunesi\xeb",
    TO: "Tonga",
    TR: "T\xfcrkiye",
    TT: "Trinidad en Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tanzania",
    UA: "Oekra\xefne",
    UG: "Oeganda",
    UK: "Verenigd Koninkrijk",
    US: "Verenigde Staten",
    UY: "Uruguay",
    UZ: "Oezbekistan",
    VA: "Vaticaanstad",
    VC: "Saint Vincent en de Grenadines",
    VE: "Venezuela",
    VG: "Britse Maagdeneilanden",
    VI: "Amerikaanse Maagdeneilanden",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis en Futuna",
    WS: "Samoa",
    XK: "",
    YE: "Jemen",
    YT: "Mayotte",
    ZA: "Zuid-Afrika",
    ZM: "Zambia",
    ZW: "Zimbabwe"
}), _define_property(_obj, EN_NL_LOCALE, EN_COUNTRY_LOCALE), _define_property(_obj, ES_US_LOCALE, {
    AF: "Afganist\xe1n",
    AL: "Albania",
    DE: "Alemania",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    SA: "Arabia Saudita",
    DZ: "Argelia",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BH: "Bahrain",
    BS: "Bahamas",
    BD: "Bangladesh",
    BB: "Barbados",
    BE: "B\xe9lgica",
    BZ: "Belice",
    BJ: "Benin",
    BM: "Bermuda",
    BY: "Bielorrusia",
    BO: "Bolivia",
    BA: "Bosnia y Herzegovina",
    BW: "Botsuana",
    BR: "Brasil",
    BN: "Brun\xe9i",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BT: "But\xe1n",
    BI: "Burundi",
    CV: "Cabo Verde",
    KH: "Camboya",
    CM: "Camer\xfan",
    CA: "Canad\xe1",
    QA: "Catar",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CY: "Chipre",
    VA: "Ciudad del Vaticano",
    CO: "Colombia",
    KM: "Comoras",
    CG: "Rep\xfablica del Congo",
    KP: "North Korea",
    KR: "Corea del Sur",
    CI: "Costa de Marfil",
    CR: "Costa Rica",
    HR: "Croacia",
    CU: "Cuba",
    CW: "Curazao",
    CD: "Rep\xfablica Democr\xe1tica del Congo",
    DK: "Dinamarca",
    DM: "Dominica",
    EC: "Ecuador",
    EG: "Egipto",
    SV: "El Salvador",
    AE: "Emiratos \xc1rabes Unidos",
    ER: "Eritrea",
    SK: "Eslovaquia",
    SI: "Eslovenia",
    ES: "Espa\xf1a",
    US: "Estados Unidos",
    EE: "Estonia",
    SZ: "Esuatini",
    ET: "Etiop\xeda",
    FJ: "Fiyi",
    PH: "Filipinas",
    FI: "Finlandia",
    FR: "Francia",
    GA: "Gab\xf3n",
    GM: "Gambia",
    GH: "Ghana",
    GE: "Georgia",
    GI: "Gibraltar",
    GD: "Granada",
    GR: "Grecia",
    GL: "Groenlandia",
    GP: "Guadalupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GQ: "Guinea Ecuatorial",
    GW: "Guinea-Bis\xe1u",
    GY: "Guyana",
    GF: "Guayana Francesa",
    HT: "Hait\xed",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungr\xeda",
    IN: "India",
    ID: "Indonesia",
    IQ: "Irak",
    IR: "Ir\xe1n",
    IE: "Irlanda",
    IM: "Isla de Man",
    CX: "Isla de Navidad",
    NF: "Isla Norfolk",
    IS: "Islandia",
    AX: "Islas \xc5land",
    KY: "Islas Caim\xe1n",
    CC: "Islas Cocos",
    CK: "Islas Cook",
    FO: "Islas Feroe",
    FK: "Islas Malvinas",
    MP: "Islas Marianas del Norte",
    MH: "Islas Marshall",
    SB: "Islas Salom\xf3n",
    SJ: "Svalbard y Jan Mayen",
    VG: "Islas V\xedrgenes Brit\xe1nicas",
    VI: "Islas V\xedrgenes de los Estados Unidos",
    IL: "Israel",
    IT: "Italia",
    JM: "Jamaica",
    JP: "Jap\xf3n",
    JE: "Jersey",
    JO: "Jordania",
    KZ: "Kazajist\xe1n",
    KE: "Kenia",
    KG: "Kirguist\xe1n",
    KI: "Kiribati",
    KW: "Kuwait",
    LA: "Laos",
    LV: "Letonia",
    LS: "Lesoto",
    LB: "L\xedbano",
    LR: "Liberia",
    LY: "Libia",
    LI: "Liechtenstein",
    LT: "Lituania",
    LU: "Luxemburgo",
    MO: "Macao",
    MK: "Macedonia",
    MG: "Madagascar",
    MY: "Malasia",
    MW: "Malaui",
    MV: "Maldivas",
    ML: "Mali",
    MT: "Malta",
    MA: "Marruecos",
    MQ: "Martinica",
    MR: "Mauritania",
    MU: "Mauricio",
    YT: "Mayotte",
    MX: "M\xe9xico",
    FM: "Micronesia",
    MD: "Moldavia",
    MC: "M\xf3naco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Pa\xedses Bajos",
    BQ: "Caribe Neerland\xe9s",
    NC: "Nueva Caledonia",
    NZ: "Nueva Zelanda",
    NI: "Nicaragua",
    NE: "N\xedger",
    NG: "Nigeria",
    NU: "Niue",
    NO: "Noruega",
    OM: "Oman",
    PK: "Pakist\xe1n",
    PW: "Palaos",
    PA: "Panam\xe1",
    PG: "Pap\xfaa Nueva Guinea",
    PY: "Paraguay",
    PE: "Per\xfa",
    PF: "Polinesia Francesa",
    PL: "Polonia",
    PT: "Portugal",
    PR: "Puerto Rico",
    GB: "Reino Unido",
    UK: "Reino Unido",
    CF: "Rep\xfablica Centroafricana",
    CZ: "Rep\xfablica Checa",
    DO: "Rep\xfablica Dominicana",
    RE: "Reuni\xf3n",
    RW: "Ruanda",
    RO: "Rumania",
    RU: "Rusia",
    EH: "Sahara Occidental",
    WS: "Samoa",
    AS: "Samoa Americana",
    BL: "San Bartolom\xe9",
    KN: "San Crist\xf3bal y Nieves",
    SM: "San Marino",
    MF: "San Mart\xedn",
    PM: "San Pedro y Miquel\xf3n",
    VC: "San Vicente y las Granadinas",
    LC: "Santa Luc\xeda",
    SH: "Santa Elena",
    ST: "Santo Tom\xe9 y Pr\xedncipe",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leona",
    SG: "Singapur",
    SY: "Siria",
    SX: "Sint Maarten",
    SO: "Somalia",
    LK: "Sri Lanka",
    ZA: "Sud\xe1frica",
    SS: "Sud\xe1n del Sur",
    SD: "Sud\xe1n",
    SE: "Suecia",
    CH: "Suiza",
    SR: "Surinam",
    TH: "Tailandia",
    TW: "Taiw\xe1n",
    TZ: "Tanzania",
    TJ: "Tayikist\xe1n",
    IO: "Territorio Brit\xe1nico del Oc\xe9ano \xcdndico",
    PS: "Palestina",
    TL: "Timor Oriental",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad y Tobago",
    TN: "T\xfanez",
    TM: "Turkmenist\xe1n",
    TC: "Islas Turcas y Caicos",
    TR: "T\xfcrkiye",
    TV: "Tuvalu",
    UA: "Ucrania",
    UG: "Uganda",
    UY: "Uruguay",
    UZ: "Uzbekist\xe1n",
    VU: "Vanuatu",
    DJ: "Yibuti",
    VE: "Venezuela",
    VN: "Vietnam",
    WF: "Wallis y Futuna",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabue",
    XK: "Kosovo"
}), _define_property(_obj, EN_GB_LOCALE, EN_COUNTRY_LOCALE), _define_property(_obj, EN_US_LOCALE, EN_COUNTRY_LOCALE), _obj);
var _obj1;
var SHORT_FRIENDLY_NAME = (_obj1 = {}, _define_property(_obj1, DE_DE_LOCALE, {
    US: "US"
}), _define_property(_obj1, EN_DE_LOCALE, {
    US: "US"
}), _define_property(_obj1, EN_US_LOCALE, {
    US: "US"
}), _define_property(_obj1, ES_US_LOCALE, {
    US: "US"
}), _define_property(_obj1, EN_FR_LOCALE, {
    US: "US"
}), _define_property(_obj1, FR_FR_LOCALE, {
    US: "US"
}), _define_property(_obj1, EN_NL_LOCALE, {
    US: "US"
}), _define_property(_obj1, NL_NL_LOCALE, {
    US: "VS"
}), _obj1);
var _obj2, _obj3, _obj4, _obj5;
var SEARCHABLE_COUNTRY_ALIASES_BY_LANGUAGE = {
    CZ: (_obj2 = {}, _define_property(_obj2, EN_LANGUAGE, [
        "Czechia"
    ]), _define_property(_obj2, DE_LANGUAGE, [
        "Tschechien"
    ]), _obj2),
    BY: _define_property({}, DE_LANGUAGE, [
        "Belarus"
    ]),
    BE: _define_property({}, DE_LANGUAGE, [
        "Bosnien"
    ]),
    NL: (_obj3 = {}, _define_property(_obj3, EN_LANGUAGE, [
        "Holland"
    ]), _define_property(_obj3, DE_LANGUAGE, [
        "Holland"
    ]), _obj3),
    GB: (_obj4 = {}, _define_property(_obj4, EN_LANGUAGE, [
        "UK",
        "Great britain",
        "britain",
        "England"
    ]), _define_property(_obj4, DE_LANGUAGE, [
        "England",
        "UK",
        "Gro\xdfbrittanien"
    ]), _obj4),
    US: (_obj5 = {}, _define_property(_obj5, EN_LANGUAGE, [
        "USA",
        "America"
    ]), _define_property(_obj5, DE_LANGUAGE, [
        "america",
        "USA",
        "Amerika",
        "Vereinigte Staaten von Amerika"
    ]), _obj5)
};

export { ALL_COUNTRIES, ALL_COUNTRY_ALIASES, COUNTRY_ISO_ALIASES_MAP, EUROPEAN_GDPR_COUNTRIES, FRIENDLY_NAME, SEARCHABLE_COUNTRY_ALIASES_BY_LANGUAGE, SHORT_FRIENDLY_NAME };
